import React, { useState } from 'react';
import { Button, Nav } from 'react-bootstrap';
import { RootState } from 'v2/models';
import { InviteTeamMemberModal } from './InviteTeamMemberModal/InviteTeamMemberModal';
import { InvitedUsersTab } from './tabs/InvitedUsersTab/InvitedUsersTab';
import { MembersTab } from './tabs/MembersTab/MembersTab';
import ReviewLicensesModal from './tabs/MembersTab/BuyerMembersList/ModalReviewLicenses/ReviewLicensesModal';
import { useSelector } from 'react-redux';
import { useRouteMatch, Link, Route, Switch } from 'react-router-dom';
import { useInfiniteStrapiUsers, useInfiniteUserInvites } from 'v2/queries';

type TabLinkProps = {
  path: string;
  url: string;
  name: string;
};

function TabLink({ path, url, name }: TabLinkProps) {
  return (
    <Nav.Item className="py-3 mr-5">
      <Nav.Link
        className="p-0 pb-2"
        as={Link}
        to={`${path}${url}`}
        eventKey={`${path}${url}`}
      >
        {name}
      </Nav.Link>
    </Nav.Item>
  );
}

enum MyTeamTabs {
  Members = 'members',
  InvitedUsers = 'invited-users',
}

const BuyerMyTeam = () => {
  const [showInviteTeamMemberModal, setShowInviteTeamMemberModal] =
    useState(false);
  const [showReviewLicenses, setShowReviewLicenses] = useState(false);
  const user = useSelector((state: RootState) => state.user.user);
  const { path } = useRouteMatch();
  const { data: strapiUsersData } = useInfiniteStrapiUsers();
  const { data: userInvitesData } = useInfiniteUserInvites();

  const handleCloseReviewLicensesModal = () => {
    setShowReviewLicenses(false);
  };

  return (
    <>
      <div className="mb-4 d-flex align-items-center justify-content-between">
        <h4>My Team</h4>

        <div className={'d-flex flex-row'}>
          <Button
            className={'btn-secondary-dark bg-white'}
            variant="secondary"
            onClick={() => setShowReviewLicenses(true)}
          >
            AVAILABLE LICENSES
          </Button>

          <Button
            className={'btn-secondary-dark ml-3'}
            variant="secondary"
            onClick={() => setShowInviteTeamMemberModal(true)}
          >
            INVITE TEAM MEMBER
          </Button>
        </div>
      </div>

      <Nav
        className="basic-nav-tab"
        defaultActiveKey={`${path}${MyTeamTabs.Members}`}
      >
        <TabLink
          path={path}
          url={MyTeamTabs.Members}
          name={`MEMBERS (${strapiUsersData?.pages[0]?.count ?? 0})`}
        />
        <TabLink
          path={path}
          url={MyTeamTabs.InvitedUsers}
          name={`INVITED USERS (${userInvitesData?.pages[0]?.count ?? 0})`}
        />
      </Nav>

      <div className="px-0 pt-4">
        <Switch>
          <Route path={[`${path}`, `${path}${MyTeamTabs.Members}`]} exact>
            <MembersTab />
          </Route>
          <Route path={`${path}${MyTeamTabs.InvitedUsers}`} exact>
            <InvitedUsersTab />
          </Route>
        </Switch>
      </div>

      <InviteTeamMemberModal
        show={showInviteTeamMemberModal}
        onClose={() => setShowInviteTeamMemberModal(false)}
      />
      {showReviewLicenses && (
        <ReviewLicensesModal
          onClose={handleCloseReviewLicensesModal}
          member={user}
          readOnly={true}
        />
      )}
    </>
  );
};

export default BuyerMyTeam;
